import { Component } from '@angular/core';
import { Constants } from 'src/app/models/constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  readonly Constants = Constants;
  readonly year = new Date().getFullYear();
}
